export const termsPagePl = {
  header: {
    title: "Regulamin świadczenia usług Alfa Gym",
    version: "Wersja: 2.0 | Obowiązuje od: 13.01.2026 r. | Ostatnia aktualizacja: 28.05.2026 r.",
  },
  intro: [
    "Niniejszy Regulamin określa zasady korzystania z siłowni samoobsługowej Alfa Gym, sprzedaży usług, dokonywania rezerwacji, zasad dostępu do Obiektu oraz praw i obowiązków Klienta i Operatora.",
    "Regulamin należy czytać łącznie z Polityką prywatności i plików cookies, która zawiera informacje o przetwarzaniu danych osobowych, monitoringu oraz wykorzystywaniu plików cookies.",
  ],
  sections: [
    {
      title: "Informacje podstawowe",
      blocks: [
        {
          type: "companyBox",
          name: "Alfa Gym Sp. z o.o.",
          addressLines: [
            "ul. Prezydenta Gabriela Narutowicza 40/1",
            "90-135 Łódź, Polska",
          ],
          metaLines: [
            "NIP: 7252354801",
            "REGON: 541553912",
            "KRS: 0001169812",
          ],
          email: "kontakt@alfagym.pl",
        },
        {
          type: "info",
          paragraphs: ["Kontakt"],
          strongFirst: true,
          labeled: [
            { label: "E-mail", text: "kontakt@alfagym.pl" },
            { label: "Telefon", text: "+48 786 087 447" },
            { label: "Godziny kontaktu telefonicznego", text: "10:00-14:00 w dni robocze" },
            { label: "E-mail i formularz kontaktowy", text: "24/7" },
            { label: "Czas odpowiedzi", text: "do 48 godzin w dni robocze" },
          ],
        },
        {
          type: "info",
          paragraphs: ["Lokalizacja Obiektu (Siłowni)"],
          strongFirst: true,
          labeled: [
            { label: "Obiekt", text: "Alfa Gym - siłownia samoobsługowa" },
            {
              label: "Adres",
              text: "ul. Cedry 6, lokal nr 6, Łódź (oznaczony szyldem „Alfa Gym Sp. z o.o.”)",
            },
            {
              label: "Uwaga",
              text: "Lokalizacja Obiektu różni się od adresu siedziby Operatora.",
            },
          ],
        },
        {
          type: "info",
          paragraphs: ["Godziny dostępności Obiektu"],
          strongFirst: true,
          labeled: [{ label: "Godziny", text: "codziennie 5:00-24:00" }],
        },
        {
          type: "subsection",
          title: "Kanały sprzedaży",
          blocks: [
            {
              type: "list",
              items: [
                "Kanał online: sprzedaż wejść jednorazowych, karnetów oraz usług dodatkowych, w tym usługi CheckUP i pakietów CheckUP za pośrednictwem Serwisu.",
                "Kanał stacjonarny: sprzedaż usługi CheckUP realizowanej w Obiekcie; usługa może zostać umówiona również telefonicznie.",
              ],
            },
          ],
        },
        {
          type: "paragraph",
          text: "Dokumentem powiązanym z Regulaminem jest Polityka prywatności i plików cookies.",
        },
      ],
    },
    {
      title: "1. Postanowienia ogólne",
      blocks: [
        {
          type: "list",
          items: [
            "Regulamin ma zastosowanie do sprzedaży usług prowadzonej online za pośrednictwem Serwisu internetowego www.alfagym.pl i powiązanego systemu rezerwacji, jak również do sprzedaży prowadzonej na miejscu w Obiekcie w zakresie wskazanym w Regulaminie.",
            "Warunkiem skorzystania z usług Operatora jest zapoznanie się z Regulaminem i jego akceptacja, w szczególności przy zakupie online, oraz przestrzeganie zasad bezpieczeństwa i porządkowych obowiązujących w Obiekcie.",
            "Oferta Operatora, cennik oraz opisy usług są dostępne w Serwisie. Zmiana cennika nie stanowi zmiany Regulaminu.",
            "Regulamin jest dostępny bezpłatnie na stronie internetowej www.alfagym.pl, a na żądanie także drogą e-mailową.",
            "Regulamin stanowi wzorzec umowny w rozumieniu art. 384 Kodeksu cywilnego.",
            "Akceptacja Regulaminu przez Klienta, w szczególności poprzez złożenie oświadczenia o akceptacji w Serwisie, oznacza zawarcie umowy o świadczenie usług na warunkach określonych w Regulaminie.",
          ],
        },
      ],
    },
    {
      title: "2. Definicje",
      blocks: [
        {
          type: "labeledParagraphs",
          items: [
            {
              label: "Serwis",
              text: "serwis internetowy dostępny pod adresem www.alfagym.pl, prowadzony i administrowany przez Operatora, umożliwiający rezerwację usług.",
            },
            {
              label: "Operator",
              text: "Alfa Gym Sp. z o.o. z siedzibą w Łodzi, ul. Prezydenta Gabriela Narutowicza 40/1, 90-135 Łódź, NIP 7252354801, REGON 541553912, KRS 0001169812.",
            },
            {
              label: "Obiekt / Siłownia",
              text: "samoobsługowy obiekt sportowo-rekreacyjny pod marką Alfa Gym przy ul. Cedry 6, lokal nr 6 w Łodzi, udostępniany Klientom na podstawie opłaconej rezerwacji.",
            },
            {
              label: "Klient / Użytkownik",
              text: "osoba fizyczna korzystająca z Serwisu lub Obiektu, w szczególności dokonująca rezerwacji lub zakupu usługi; Klientem nie jest osoba towarzysząca, chyba że zawrze odrębną umowę z Operatorem.",
            },
            {
              label: "Umowa",
              text: "umowa o świadczenie usług zawierana pomiędzy Klientem a Operatorem za pośrednictwem Serwisu lub w Obiekcie.",
            },
            {
              label: "Usługa / Usługi",
              text: "usługi świadczone przez Operatora, obejmujące w szczególności udostępnienie Obiektu w zarezerwowanym czasie wejścia, wejścia jednorazowe, karnety, usługę Technogym CheckUP oraz inne usługi z aktualnej oferty.",
            },
            {
              label: "Usługi elektroniczne",
              text: "usługi świadczone drogą elektroniczną obejmujące umożliwienie zawarcia umowy, dokonania i opłacenia rezerwacji oraz przesyłanie powiadomień e-mail i SMS związanych z realizacją usług.",
            },
            {
              label: "Rezerwacja",
              text: "zarezerwowanie konkretnego terminu oraz czasu wejścia do Obiektu w ramach wykupionej usługi lub karnetu, skuteczne z chwilą potwierdzenia w Serwisie.",
            },
            {
              label: "Czas wejścia",
              text: "określony przedział czasowy, w którym Klient jest uprawniony do korzystania z Obiektu zgodnie z dokonaną rezerwacją oraz zakupioną usługą.",
            },
            {
              label: "Jednostka rozliczeniowa / Jednostka",
              text: "jednostka rozliczeniowa odpowiadająca jednemu zarezerwowanemu czasowi wejścia, zgodnie z wariantem usługi zakupionej przez Klienta.",
            },
            {
              label: "Karnet",
              text: "imienny pakiet Jednostek rozliczeniowych przypisanych do Klienta, ważny przez 45 dni od dnia zakupu, chyba że oferta stanowi inaczej.",
            },
            {
              label: "System Dostępu",
              text: "system kontroli dostępu do Obiektu umożliwiający wejście na podstawie Kodu dostępu.",
            },
            {
              label: "Kod dostępu",
              text: "indywidualny elektroniczny kod umożliwiający wejście do Obiektu w ramach ważnej rezerwacji.",
            },
            {
              label: "Miejsce postojowe",
              text: "wyznaczone miejsce parkingowe przypisane do Obiektu.",
            },
            {
              label: "Usługa CheckUP",
              text: "usługa diagnostyczno-analityczna realizowana przez Operatora z wykorzystaniem urządzenia Technogym CheckUP, wykonywana wyłącznie w obecności Operatora lub osoby przez niego upoważnionej.",
            },
            {
              label: "Trener",
              text: "osoba prowadząca trening personalny, dopuszczona do korzystania z Obiektu po uprzedniej weryfikacji i akceptacji przez Operatora.",
            },
            {
              label: "Osoba towarzysząca",
              text: "osoba fizyczna niebędąca Klientem, która przebywa w Obiekcie wyłącznie w ramach rezerwacji Klienta, za jego zgodą i na jego odpowiedzialność, po wcześniejszym zgłoszeniu Operatorowi.",
            },
            {
              label: "Opłata dodatkowa",
              text: "zryczałtowana opłata nakładana przez Operatora w przypadku naruszenia Regulaminu.",
            },
            {
              label: "Dni robocze",
              text: "dni od poniedziałku do piątku z wyłączeniem dni ustawowo wolnych od pracy w Polsce.",
            },
          ],
        },
      ],
    },
    {
      title: "3. Kanały sprzedaży oraz rodzaje usług",
      blocks: [
        {
          type: "list",
          items: [
            "Operator prowadzi sprzedaż usług online za pośrednictwem Serwisu oraz stacjonarnie w zakresie usługi CheckUP.",
            "Zawarcie umowy o świadczenie usługi CheckUP następuje z chwilą dokonania płatności przez Klienta albo, przy płatności na miejscu, z chwilą złożenia zamówienia i jego potwierdzenia przez Operatora.",
            "Realizacja usługi CheckUP odbywa się w terminie ustalonym pomiędzy Klientem a Operatorem.",
            "Termin realizacji może zostać ustalony przez kontakt Operatora z Klientem w terminie do 48 godzin od zakupu albo przez kontakt Klienta z Operatorem.",
            "Brak kontaktu po jednej ze stron nie zwalnia z obowiązku współdziałania w celu ustalenia terminu realizacji usługi.",
            "Szczegółowy zakres usług, ich ceny oraz warunki świadczenia określane są każdorazowo w aktualnej ofercie udostępnionej w Serwisie.",
            "Operator może wprowadzać kody rabatowe na zasadach określonych w warunkach danej promocji.",
            "Kody rabatowe co do zasady nie podlegają łączeniu i zwykle nie obejmują karnetów oraz pakietów CheckUP, chyba że warunki konkretnej promocji stanowią inaczej.",
          ],
        },
      ],
    },
    {
      title: "4. Usługi elektroniczne",
      blocks: [
        {
          type: "list",
          items: [
            "Klient zobowiązany jest do podania prawdziwych, kompletnych i aktualnych danych niezbędnych do realizacji umowy, w szczególności imienia, nazwiska, adresu e-mail oraz numeru telefonu.",
            "W przypadku rezerwacji z udziałem osoby towarzyszącej Klient zobowiązany jest do podania jej imienia i nazwiska oraz oświadcza, że jest uprawniony do przekazania tych danych i poinformował tę osobę o ich przekazaniu.",
            "W przypadku rezerwacji z udziałem Trenera Klient wybiera Trenera z listy dostępnej w Serwisie albo uzyskuje uprzednią akceptację Operatora dla Trenera spoza listy.",
            "Przekazując dane Trenera, Klient oświadcza, że jest uprawniony do ich podania i poinformował Trenera o przekazaniu danych Operatorowi.",
            "Podanie danych nieprawdziwych, niepełnych, cudzych lub nieaktualnych, w tym danych dotyczących osób towarzyszących lub Trenera, jest zabronione.",
            "Operator jest uprawniony do jednorazowej lub wyrywkowej weryfikacji zgodności danych z dokumentem tożsamości w zakresie niezbędnym do zapewnienia bezpieczeństwa i realizacji usługi.",
            "W razie istotnej rozbieżności danych Operator może odmówić udzielenia dostępu do Obiektu, anulować rezerwację lub wstrzymać realizację usługi do czasu wyjaśnienia sprawy.",
            "Jeżeli podanie nieprawdziwych danych uniemożliwia wykonanie umowy lub kontakt z Klientem, uznaje się to za okoliczność leżącą po stronie Klienta.",
            "Powyższe nie wyłącza prawa Operatora do dochodzenia roszczeń na zasadach ogólnych.",
            "Szczegółowe zasady przetwarzania danych osobowych określa Polityka Prywatności dostępna w Serwisie oraz w Obiekcie.",
          ],
        },
      ],
    },
    {
      title: "5. Karnety oraz zasady ich rozliczania",
      blocks: [
        {
          type: "list",
          items: [
            "Usługi świadczone przez Operatora mogą być rozliczane w ramach Karnetów wyrażonych w Jednostkach rozliczeniowych.",
            "Każda rezerwacja dokonana w ramach Karnetu powoduje odliczenie jednej Jednostki zgodnie z zakupionym wariantem czasu wejścia.",
            "Karnet jest ważny przez okres 45 dni od dnia zakupu. Po upływie tego okresu niewykorzystane Jednostki wygasają, z zastrzeżeniem przypadków, gdy brak możliwości rezerwacji wynika z przyczyn leżących po stronie Operatora.",
            "Usługa CheckUP nie jest rozliczana w ramach Karnetu.",
            "Skrócenie czasu korzystania z Obiektu przez Klienta nie uprawnia do zwrotu środków.",
            "W przypadku braku możliwości dokonania rezerwacji z przyczyn leżących po stronie Operatora okres ważności Karnetu ulega przedłużeniu o czas trwania przeszkody.",
            "Rezerwacji w ramach Karnetu można dokonywać z wyprzedzeniem do 90 dni kalendarzowych.",
            "Operator oferuje Karnety o różnej liczbie Jednostek oraz wariantach czasu wejścia.",
            "Karnety mają charakter imienny, chyba że Operator wyraźnie dopuści możliwość ich przeniesienia.",
            "Niewykorzystanie Karnetu z przyczyn nieleżących po stronie Operatora nie uprawnia do zwrotu opłaty, przedłużenia okresu ważności ani wymiany niewykorzystanych wejść na inne świadczenie.",
          ],
        },
      ],
    },
    {
      title: "6. Usługa CheckUP i pakiety CheckUP",
      blocks: [
        {
          type: "list",
          items: [
            "Usługa CheckUP stanowi usługę diagnostyczno-analityczną realizowaną przy użyciu urządzenia Technogym CheckUP i świadczoną wyłącznie przez Operatora lub osoby przez niego upoważnione.",
            "Usługa CheckUP może być oferowana jako pojedyncza usługa albo w formie pakietu obejmującego 3, 6 lub 9 usług CheckUP.",
            "Pakiet CheckUP uprawnia Klienta do skorzystania z określonej liczby usług w okresie 90 dni od dnia zakupu.",
            "Zawarcie umowy następuje przy płatności online z chwilą dokonania płatności, przy płatności w Obiekcie z chwilą dokonania rezerwacji i jej potwierdzenia przez Operatora, a przy zakupie stacjonarnym z chwilą przyjęcia zamówienia przez Operatora.",
            "Rezerwacja terminu realizacji usługi CheckUP jest elementem organizacji usługi i nie stanowi jeszcze jej wykonania.",
            "Operator zapewnia możliwość ustalenia terminu realizacji usługi w rozsądnym czasie z uwzględnieniem dostępności terminów.",
            "Po zakupie usługi lub pakietu Operator podejmuje kontakt z Klientem w celu ustalenia terminu, a Klient może również skontaktować się samodzielnie.",
            "Klient jest uprawniony do skorzystania z usługi lub pakietu w okresie 90 dni od dnia zakupu. Jeśli brak możliwości ustalenia terminu wynika z przyczyn leżących po stronie Operatora, okres ten ulega odpowiedniemu przedłużeniu.",
            "Niewykorzystanie usługi z przyczyn leżących wyłącznie po stronie Klienta nie uprawnia do zwrotu środków, z zastrzeżeniem przepisów bezwzględnie obowiązujących.",
            "Klient może odwołać ustalony termin nie później niż 24 godziny przed wizytą. W przypadku nieodwołania wizyty w terminie lub niepojawienia się Klienta dana jednostkowa usługa uznawana jest za wykonaną.",
            "Zabrania się samodzielnego uruchamiania lub ingerencji w urządzenie Technogym CheckUP bez nadzoru Operatora lub osoby przez niego wyznaczonej.",
            "Naruszenie powyższego zakazu może skutkować opłatą dodatkową w wysokości 2000 zł oraz dochodzeniem odszkodowania na zasadach ogólnych.",
            "Korzystanie z urządzenia Technogym CheckUP może wiązać się z przetwarzaniem danych dotyczących zdrowia Użytkownika. Szczegółowe informacje w tym zakresie znajdują się w Polityce Prywatności.",
            "Wyniki usługi CheckUP mogą być udostępniane za pośrednictwem aplikacji Technogym, systemów informatycznych Operatora udostępnionych przez producenta urządzenia lub wiadomości e-mail.",
          ],
        },
      ],
    },
    {
      title: "7. Rezerwacje, spóźnienia oraz odwołania",
      blocks: [
        {
          type: "list",
          items: [
            "Rezerwacja dokonywana jest za pośrednictwem Serwisu poprzez wybór terminu i czasu wejścia, podanie wymaganych danych oraz dokonanie płatności.",
            "Po skutecznym zawarciu umowy Użytkownik otrzymuje indywidualny Kod dostępu do Obiektu w systemie TTLock lub innym równoważnym systemie kontroli dostępu.",
            "Kod dostępu pozostaje aktywny wyłącznie w okresie wykupionego czasu wejścia. W tym czasie Użytkownik może wielokrotnie wchodzić i wychodzić z Obiektu, o ile nie narusza zasad bezpieczeństwa i Regulaminu.",
            "Spóźnienie Użytkownika nie powoduje przedłużenia wykupionego czasu wejścia.",
            "W przypadku późniejszego rozpoczęcia korzystania z Obiektu Użytkownik ma prawo korzystać wyłącznie w pozostałym czasie rezerwacji.",
            "W Obiekcie może znajdować się system odmierzania czasu korzystania, w szczególności zegar lub system wizualnego odliczania czasu.",
            "Po upływie wykupionego czasu wejścia systemy oświetlenia lub inne instalacje mogą zostać automatycznie ograniczone lub wyłączone w sposób sygnalizujący zakończenie rezerwacji.",
          ],
        },
        {
          type: "subsection",
          title: "Dobrowolna polityka odwołania rezerwacji",
          blocks: [
            {
              type: "list",
              items: [
                "Odwołanie rezerwacji może nastąpić nie później niż 24 godziny przed rozpoczęciem czasu wejścia.",
                "W przypadku skutecznego odwołania Użytkownik otrzymuje voucher odpowiadający wartości niewykorzystanej usługi.",
                "Odwołania dokonane po upływie wskazanego terminu nie uprawniają do otrzymania vouchera ani zwrotu środków, z zastrzeżeniem sytuacji, gdy brak realizacji usługi wynika z przyczyn leżących po stronie Operatora.",
                "Jeżeli brak możliwości skorzystania z usługi wynika z awarii systemu dostępu, systemu rezerwacji lub Obiektu, Użytkownik zachowuje prawo do realizacji usługi w innym terminie albo do otrzymania vouchera.",
                "Voucher nie przysługuje, jeżeli brak realizacji usługi wynika z przyczyn leżących po stronie Użytkownika, w szczególności z podania nieprawidłowych danych, nieprawidłowego korzystania z Kodu dostępu albo naruszenia Regulaminu.",
              ],
            },
          ],
        },
      ],
    },
    {
      title: "8. Płatności oraz dokumenty sprzedaży",
      blocks: [
        {
          type: "list",
          items: [
            "Płatności online realizowane są za pośrednictwem bramki płatniczej Paynow.",
            "Podmiotem świadczącym obsługę płatności online jest mElements S.A.",
            "Dane płatnicze Użytkownika przetwarzane są wyłącznie przez Paynow zgodnie z jego regulaminem i polityką prywatności.",
            "Wszystkie ceny podawane są w złotych polskich (PLN) i są cenami brutto, o ile oferta nie stanowi inaczej.",
            "Dostępne formy płatności obejmują m.in. karty płatnicze, BLIK oraz inne metody udostępnione w bramce Paynow.",
            "Potwierdzenie transakcji oraz szczegóły rezerwacji przesyłane są na adres e-mail podany przez Klienta; wiadomość SMS zawiera co najmniej datę wejścia, godzinę wejścia oraz Kod dostępu.",
            "Operator nie ponosi odpowiedzialności za niedostarczenie wiadomości SMS z przyczyn leżących po stronie operatorów telekomunikacyjnych lub urządzenia Użytkownika.",
            "Czas realizacji zamówienia liczony jest od momentu pozytywnej autoryzacji płatności lub wpływu środków w przypadku metod odroczonych.",
            "Wybrany termin rezerwacji jest tymczasowo blokowany na 5 minut w celu dokończenia transakcji.",
            "Płatności na miejscu dotyczą wyłącznie usługi CheckUP i mogą być realizowane gotówką, kartą płatniczą lub BLIK.",
            "Faktury wystawiane są wyłącznie na żądanie Klienta zgłoszone w chwili zakupu. Po zakończeniu transakcji późniejsze wystawienie faktury nie jest możliwe.",
            "W przypadku płatności dokonywanych na miejscu Operator wystawia paragon fiskalny oraz, na żądanie zgłoszone przed dokonaniem płatności, fakturę.",
            "Logotypy organizacji kartowych oraz Paynow mogą być prezentowane w Serwisie wyłącznie w celach informacyjnych i pozostają własnością odpowiednich podmiotów.",
            "Operator nie jest dostawcą usług płatniczych i nie przetwarza danych kart płatniczych Użytkownika.",
          ],
        },
      ],
    },
    {
      title: "9. Zasady dostępu oraz osoby uprawnione",
      blocks: [
        {
          type: "list",
          items: [
            "Z usług oraz Obiektu mogą korzystać wyłącznie osoby pełnoletnie, z zastrzeżeniem korzystania przez osoby niepełnoletnie pod stałym nadzorem osoby pełnoletniej.",
            "Osoba pełnoletnia sprawująca nadzór nad osobą niepełnoletnią musi być obecna w Obiekcie przez cały czas korzystania, zostać zgłoszona zgodnie z Regulaminem i ponosi pełną odpowiedzialność za bezpieczeństwo oraz zachowanie osoby niepełnoletniej.",
            "Trener może sprawować nadzór nad osobą niepełnoletnią wyłącznie wtedy, gdy został zgłoszony zgodnie z Regulaminem oraz posiada odpowiednie kwalifikacje.",
            "Jeden opiekun lub Trener może sprawować nadzór maksymalnie nad jedną osobą niepełnoletnią.",
            "Użytkownik zobowiązany jest do korzystania ze sprzętu zgodnie z jego przeznaczeniem, instrukcjami użytkowania oraz zasadami bezpieczeństwa i do niezwłocznego zgłaszania wszelkich usterek.",
            "Na terenie Obiektu obowiązuje zakaz wprowadzania zwierząt, z wyjątkiem psów asystujących w rozumieniu przepisów prawa.",
            "Obiekt stanowi przestrzeń prywatną i w danym przedziale czasowym udostępniany jest wyłącznie Użytkownikowi oraz osobom zgłoszonym zgodnie z Regulaminem.",
            "Osoby towarzyszące oraz Trener muszą zostać zgłoszeni przed rozpoczęciem rezerwacji w sposób określony w Serwisie.",
            "Maksymalna liczba osób przebywających w Obiekcie wynika z wybranej opcji usługi. Jej przekroczenie stanowi naruszenie Regulaminu.",
            "Użytkownik ponosi odpowiedzialność za szkody powstałe w wyniku nieprawidłowego korzystania z Obiektu lub sprzętu przez niego, osoby towarzyszące, Trenera albo osoby niepełnoletnie pozostające pod jego nadzorem.",
          ],
        },
      ],
    },
    {
      title: "10. Dostęp do Obiektu oraz zasady korzystania z kodów dostępu",
      blocks: [
        {
          type: "list",
          items: [
            "Wejście do Obiektu odbywa się przy użyciu indywidualnego Kodu dostępu udostępnianego Użytkownikowi po zakupie usługi za pośrednictwem wiadomości e-mail oraz lub SMS.",
            "Kod dostępu jest przypisany do konkretnej rezerwacji i okresu czasowego, pozostaje aktywny wyłącznie w ramach wykupionego przedziału czasowego i wygasa automatycznie po jego upływie.",
            "Kod dostępu ma charakter poufny i zabrania się jego udostępniania osobom trzecim.",
            "Z Obiektu mogą korzystać wyłącznie osoby wskazane w procesie zakupu lub rezerwacji zgodnie z warunkami danej usługi.",
            "W przypadku problemów z dostępem Użytkownik zobowiązany jest do niezwłocznego kontaktu z Operatorem wraz z opisem problemu.",
            "Jeżeli brak dostępu wynika z przyczyn leżących po stronie Operatora lub Systemu Dostępu, Operator zapewni możliwość skorzystania z usługi w innym terminie albo przyzna voucher odpowiadający wartości niewykorzystanej usługi.",
            "Wyjście z Obiektu od wewnątrz jest możliwe w każdym czasie niezależnie od funkcjonowania Systemu Dostępu.",
            "Operator nie ponosi odpowiedzialności za skutki wynikające z udostępnienia Kodu dostępu osobom trzecim przez Użytkownika.",
            "Operator może czasowo zawiesić lub zablokować dostęp Użytkownika do Obiektu w przypadku istotnego naruszenia Regulaminu, prób nieuprawnionego korzystania z Systemu Dostępu lub uzasadnionego podejrzenia naruszenia bezpieczeństwa.",
          ],
        },
      ],
    },
    {
      title: "11. Monitoring i bezpieczeństwo",
      blocks: [
        {
          type: "list",
          items: [
            "Obiekt może być objęty monitoringiem wizyjnym w celu zapewnienia bezpieczeństwa osób i ochrony mienia.",
            "Korzystanie z Obiektu może wiązać się z utrwalaniem wizerunku Klienta zgodnie z obowiązującymi przepisami prawa.",
            "W Obiekcie znajduje się strefa wyłączona z monitoringu, taka jak prysznice, toaleta i przebieralnia.",
            "Nagrania przechowywane są przez okres nie dłuższy niż niezbędny do realizacji celu, w szczególności zapewnienia bezpieczeństwa oraz dochodzenia lub obrony roszczeń.",
          ],
        },
      ],
    },
    {
      title: "12. Trener personalny",
      blocks: [
        {
          type: "list",
          items: [
            "Korzystanie z Obiektu z udziałem Trenera jest dopuszczalne wyłącznie w ramach odpowiedniej opcji usługi przewidzianej przez Operatora.",
            "Warunkiem dopuszczenia Trenera do Obiektu jest jego uprzednia weryfikacja oraz zatwierdzenie przez Operatora.",
            "Zweryfikowany Trener zostaje wpisany do wewnętrznej bazy trenerów prowadzonej przez Operatora.",
            "Weryfikacja Trenera odbywa się na wniosek Użytkownika lub Trenera zgłoszony za pośrednictwem dostępnych kanałów komunikacji.",
            "W ramach procesu weryfikacji Trener zobowiązany jest do przedstawienia dokumentów potwierdzających posiadanie kwalifikacji do prowadzenia treningów personalnych.",
            "Operator może odmówić akceptacji Trenera w przypadku niespełnienia wymogów formalnych lub bezpieczeństwa.",
            "Do czasu zakończenia procesu weryfikacji Użytkownik może skorzystać z Obiektu z udziałem Trenera wyłącznie poprzez wykupienie usługi przewidzianej dla co najmniej dwóch osób; w takim przypadku Trener traktowany jest jako osoba towarzysząca.",
            "Operator nie ponosi odpowiedzialności za jakość, sposób prowadzenia ani skutki treningów realizowanych przez Trenera, który nie jest stroną umowy zawartej pomiędzy Operatorem a Użytkownikiem.",
            "Prowadzenie działalności gospodarczej polegającej na świadczeniu usług treningowych na terenie Obiektu może wymagać spełnienia dodatkowych warunków organizacyjnych lub zawarcia odrębnej umowy z Operatorem.",
          ],
        },
      ],
    },
    {
      title: "13. Odpowiedzialność Użytkownika oraz osób towarzyszących",
      blocks: [
        {
          type: "list",
          items: [
            "Użytkownik ponosi odpowiedzialność za własne działania i zaniechania, jak również za działania i zaniechania osób korzystających z Obiektu w ramach jego rezerwacji, w tym osób towarzyszących oraz Trenerów.",
            "Klient oraz osoby towarzyszące ponoszą odpowiedzialność za szkody wyrządzone Operatorowi w związku z korzystaniem z Obiektu zgodnie z przepisami prawa cywilnego.",
            "W przypadku wyrządzenia szkody przez kilka osób Operator może dochodzić roszczeń od każdej z nich zgodnie z zasadami odpowiedzialności przewidzianymi przez prawo.",
            "Operator nie ponosi odpowiedzialności za urazy lub szkody wynikające z nieprawidłowego korzystania ze sprzętu, naruszenia Regulaminu albo braku dostosowania aktywności do stanu zdrowia Użytkownika lub osób działających w ramach jego rezerwacji.",
            "Operator odpowiada za utrzymanie Obiektu oraz sprzętu w stanie zgodnym z wymaganiami bezpieczeństwa wynikającymi z obowiązujących przepisów prawa.",
            "Postanowienia Regulaminu nie wyłączają ani nie ograniczają odpowiedzialności Operatora w zakresie, w jakim jej wyłączenie jest niedopuszczalne na mocy bezwzględnie obowiązujących przepisów prawa.",
            "Operator nie ponosi odpowiedzialności za rzeczy wniesione lub pozostawione w Obiekcie, chyba że szkoda powstała z winy umyślnej lub rażącego niedbalstwa Operatora. Klient jest zobowiązany zamknąć udostępnioną szafkę.",
          ],
        },
      ],
    },
    {
      title: "14. Zasady porządkowe, higiena, cisza oraz bezpieczeństwo",
      blocks: [
        {
          type: "list",
          items: [
            "Użytkownik korzysta z Obiektu na własną odpowiedzialność, z uwzględnieniem swojego stanu zdrowia oraz indywidualnych możliwości fizycznych.",
            "Przed rozpoczęciem aktywności fizycznej zalecana jest konsultacja lekarska, w szczególności w przypadku chorób przewlekłych, urazów lub innych przeciwwskazań zdrowotnych.",
            "Zabrania się wykonywania ćwiczeń w sposób stwarzający zagrożenie dla zdrowia lub życia Użytkownika albo osób trzecich.",
            "Użytkownik zobowiązany jest do korzystania z Obiektu zgodnie z zasadami higieny, bezpieczeństwa oraz współżycia społecznego.",
            "Po wejściu do Obiektu należy zmienić obuwie na czyste obuwie sportowe przeznaczone wyłącznie do ćwiczeń. Obowiązek ten dotyczy również osób towarzyszących oraz Trenera.",
            "Użytkownik zobowiązany jest do korzystania z ręcznika podczas treningu.",
            "Po każdorazowym użyciu sprzętu treningowego należy wyczyścić miejsca kontaktu przy użyciu środków dezynfekujących oraz materiałów jednorazowych udostępnionych w Obiekcie.",
            "Po zakończeniu korzystania z Obiektu należy pozostawić go w stanie niepogorszonym, w szczególności odłożyć sprzęt na właściwe miejsce i wyrzucić odpady do przeznaczonych pojemników.",
            "Na terenie Obiektu obowiązuje bezwzględny zakaz palenia wyrobów tytoniowych i e-papierosów, spożywania alkoholu, używania środków odurzających, dopingujących lub innych substancji psychoaktywnych oraz przebywania pod ich wpływem.",
            "Zabrania się rzucania ciężarami lub sprzętem, uderzania w sprzęt, jego dewastacji lub używania niezgodnie z przeznaczeniem.",
            "Korzystanie z natrysków dopuszczalne jest wyłącznie w ramach wykupionego czasu korzystania z Obiektu.",
            "Nagrania, sesje zdjęciowe lub materiały audiowizualne o charakterze komercyjnym wymagają uprzedniej zgody Operatora. Nagrania prywatne są dopuszczalne, o ile nie naruszają prywatności innych osób, przepisów prawa ani zasad bezpieczeństwa.",
            "W przypadku zadymienia, pożaru, zalania, uruchomienia systemów alarmowych lub innego zagrożenia Użytkownik zobowiązany jest do niezwłocznej ewakuacji oraz, w razie potrzeby, powiadomienia odpowiednich służb i Operatora.",
            "Użytkownik zobowiązany jest niezwłocznie zgłaszać wszelkie zauważone uszkodzenia Obiektu lub sprzętu, a także brak środków higienicznych lub materiałów eksploatacyjnych.",
            "Użytkownik zobowiązany jest zapewnić drożność dróg ewakuacyjnych i nie ingerować w urządzenia oraz elementy systemów bezpieczeństwa.",
          ],
        },
      ],
    },
    {
      title: "15. Miejsce postojowe",
      blocks: [
        {
          type: "list",
          items: [
            "Przy Obiekcie dostępne jest miejsce postojowe przeznaczone dla Klienta w czasie rezerwacji.",
            "Dojazd i wyjazd w trakcie rezerwacji są dozwolone.",
            "Obowiązuje bufor 5 minut przed rozpoczęciem oraz 10 minut po zakończeniu rezerwacji.",
            "Klient zobowiązany jest zwolnić miejsce postojowe najpóźniej po upływie bufora, aby umożliwić korzystanie kolejnemu Klientowi.",
          ],
        },
      ],
    },
    {
      title: "16. Opłaty dodatkowe",
      blocks: [
        {
          type: "alert",
          text: "W przypadku naruszenia Regulaminu Operator może naliczyć Klientowi opłaty dodatkowe.",
        },
        {
          type: "list",
          items: [
            "500 zł za pozostawanie w Obiekcie po zakończeniu czasu wejścia, zajmowanie miejsca postojowego po upływie czasu buforowego, udostępnienie Kodu dostępu osobie nieuprawnionej albo korzystanie z Obiektu przez większą liczbę osób, niż przewidziano w ramach wykupionej usługi.",
            "2000 zł za samodzielne korzystanie z urządzenia Technogym CheckUP bez obecności lub nadzoru Operatora.",
            "Opłaty dodatkowe naliczane są za każde stwierdzone naruszenie na podstawie danych systemowych, monitoringu, logów Systemu Dostępu lub innych wiarygodnych dowodów.",
            "Opłaty dodatkowe nie są naliczane, jeżeli naruszenie wynikało z awarii Systemu Dostępu lub innych przyczyn leżących po stronie Operatora.",
            "Naliczona opłata dodatkowa nie wyłącza prawa Operatora do dochodzenia odszkodowania na zasadach ogólnych, jeżeli szkoda przewyższa wysokość opłaty.",
            "Niezależnie od opłat dodatkowych Operator może obciążyć Użytkownika kosztami sprzątania, serwisu, naprawy lub usunięcia szkód spowodowanych przez Użytkownika, osoby towarzyszące, Trenera lub osoby niepełnoletnie pozostające pod jego nadzorem.",
            "Opłaty dodatkowe oraz koszty dodatkowe są płatne w terminie 7 dni od dnia doręczenia wezwania do zapłaty przesłanego e-mailem lub listownie.",
            "Brak zapłaty w terminie może skutkować czasową lub stałą blokadą dostępu do Obiektu, z zastrzeżeniem praw Użytkownika wynikających z bezwzględnie obowiązujących przepisów prawa.",
          ],
        },
      ],
    },
    {
      title: "17. Odpowiedzialność Operatora oraz wyłączenia odpowiedzialności",
      blocks: [
        {
          type: "list",
          items: [
            "Użytkownik korzysta z Obiektu oraz jego wyposażenia na własne ryzyko.",
            "Operator nie zapewnia w ramach ceny usługi ubezpieczenia od następstw nieszczęśliwych wypadków (NNW).",
            "Operator nie ponosi odpowiedzialności za szkody powstałe w związku z nieprawidłowym lub niezgodnym z przeznaczeniem korzystaniem ze sprzętu, nieprzestrzeganiem instrukcji użytkowania lub zasad bezpieczeństwa, stanem zdrowia Użytkownika ani naruszeniem Regulaminu.",
            "Odpowiedzialność Operatora wobec Użytkowników będących konsumentami oraz przedsiębiorcami na prawach konsumenta podlega ograniczeniu wyłącznie w zakresie dopuszczalnym przez bezwzględnie obowiązujące przepisy prawa.",
            "Regulamin nie wyłącza ani nie ogranicza odpowiedzialności Operatora za szkody na osobie ani odpowiedzialności, której wyłączenie jest prawnie niedopuszczalne.",
            "Operator dokłada należytej staranności w celu zapewnienia prawidłowego funkcjonowania Obiektu, jego wyposażenia oraz Systemu Dostępu, jednak nie gwarantuje ich nieprzerwanej dostępności.",
            "Dostęp do Obiektu może zostać czasowo ograniczony lub zawieszony w przypadku awarii technicznych, prac serwisowych, konserwacyjnych lub modernizacyjnych, działania siły wyższej albo innych zdarzeń pozostających poza kontrolą Operatora.",
            "W przypadku przerw w dostępności Obiektu Operator podejmie działania mające na celu ich możliwie najszybsze usunięcie.",
            "Postanowienia tego paragrafu nie wyłączają uprawnień Użytkownika wynikających z przepisów prawa w zakresie niewykonania lub nienależytego wykonania umowy.",
          ],
        },
      ],
    },
    {
      title: "18. Reklamacje",
      blocks: [
        {
          type: "list",
          items: [
            "Reklamacje można składać e-mailowo na adres kontakt@alfagym.pl.",
            "Reklamacja powinna zawierać co najmniej dane kontaktowe Klienta, datę i godzinę rezerwacji lub zakupu, opis zdarzenia oraz żądanie Klienta.",
            "Operator potwierdza otrzymanie reklamacji w tej samej formie, w jakiej została złożona, chyba że Klient wskaże inną preferowaną formę kontaktu.",
            "Operator rozpatruje reklamację w terminie 14 dni kalendarzowych od jej otrzymania lub od dnia uzupełnienia braków formalnych.",
            "Odpowiedź na reklamację udzielana jest w formie elektronicznej albo pisemnej, zgodnie z wyborem Klienta.",
            "Reklamacje dotyczące płatności online mogą wymagać kontaktu z operatorem bramki płatniczej Paynow.",
          ],
        },
      ],
    },
    {
      title: "19. Odstąpienie od Umowy oraz dobrowolne zwroty",
      blocks: [
        {
          type: "list",
          items: [
            "W przypadku zawarcia umowy na odległość Konsumentowi przysługuje prawo odstąpienia od umowy w terminie 14 dni, zgodnie z ustawą o prawach konsumenta.",
            "Prawo odstąpienia nie przysługuje w odniesieniu do umów o świadczenie usług związanych z wypoczynkiem, jeżeli w umowie oznaczono dzień lub okres świadczenia usługi.",
            "Zawarcie umowy na terminową usługę stanowi wyraźne żądanie jej wykonania w oznaczonym czasie, co może skutkować brakiem prawa odstąpienia na podstawie obowiązujących przepisów.",
            "Niezależnie od powyższego Operator może, w szczególnie uzasadnionych przypadkach, przyznać Użytkownikowi dobrowolne świadczenie w postaci vouchera odpowiadającego wartości niewykorzystanej usługi.",
            "Voucher ma charakter jednorazowy, nie podlega wymianie na środki pieniężne i może zostać wykorzystany wyłącznie w okresie jego ważności, co do zasady 30 dni od dnia wydania, chyba że Operator wskaże inaczej.",
            "Voucher może zostać wykorzystany za pośrednictwem Serwisu poprzez wybór opcji jego użycia podczas dokonywania rezerwacji.",
            "W odniesieniu do usługi CheckUP Operator może, po indywidualnym uzgodnieniu, przyznać voucher możliwy do wykorzystania wyłącznie na usługę CheckUP.",
            "Postanowienia tego paragrafu nie wyłączają ani nie ograniczają praw Konsumenta wynikających z bezwzględnie obowiązujących przepisów prawa.",
          ],
        },
      ],
    },
    {
      title: "20. Postanowienia końcowe",
      blocks: [
        {
          type: "list",
          items: [
            "Regulamin wchodzi w życie z dniem wskazanym w jego treści i podlega publikacji na stronie internetowej Operatora w aktualnej wersji.",
            "Operator zastrzega sobie prawo do zmiany Regulaminu z ważnych przyczyn, w szczególności w przypadku zmiany zakresu lub sposobu świadczenia usług, wprowadzenia nowych funkcjonalności Serwisu, zmiany obowiązujących przepisów prawa albo konieczności usunięcia niejasności, omyłek lub dostosowania postanowień do zmian organizacyjnych lub technicznych.",
            "Zmiany Regulaminu nie naruszają praw nabytych Użytkowników w odniesieniu do usług zakupionych przed datą wejścia w życie zmian, chyba że zmiana wynika z bezwzględnie obowiązujących przepisów prawa.",
            "Prawem właściwym dla zawarcia oraz wykonania umowy jest prawo polskie, z uwzględnieniem bezwzględnie obowiązujących przepisów prawa Unii Europejskiej.",
            "Wszelkie spory wynikające z umowy lub związane z korzystaniem z Obiektu będą rozstrzygane przez właściwe sądy powszechne zgodnie z obowiązującymi przepisami prawa.",
            "W sprawach nieuregulowanych Regulaminem zastosowanie mają przepisy powszechnie obowiązującego prawa, w szczególności Kodeks cywilny oraz ustawa o prawach konsumenta.",
            "Regulamin sporządzony jest w języku polskim. W przypadku udostępnienia jego wersji w innych wersjach językowych, wersją wiążącą pozostaje wersja polska.",
          ],
        },
      ],
    },
  ],
  contactCard: {
    title: "Masz pytania dotyczące Regulaminu?",
    lead: "Skontaktuj się z nami:",
    emailLabel: "E-mail",
    email: "kontakt@alfagym.pl",
    addressLabel: "Adres korespondencyjny",
    addressLines: [
      "Alfa Gym Sp. z o.o.",
      "ul. Prezydenta Gabriela Narutowicza 40/1",
      "90-135 Łódź, Polska",
    ],
    note: "W sprawach pilnych możesz również skontaktować się telefonicznie: +48 786 087 447.",
  },
};

export const termsPageEn = {
  header: {
    title: "Alfa Gym Terms of Service",
    version: "Version: 2.0 | Effective from: January 13, 2026 | Last updated: May 28, 2026",
  },
  intro: [
    "These Terms of Service set out the rules for using the Alfa Gym self-service gym, purchasing services, making reservations, accessing the Facility, and the rights and obligations of the Client and the Operator.",
    "These Terms should be read together with the Privacy and Cookies Policy, which explains personal data processing, CCTV monitoring, and the use of cookies.",
  ],
  sections: [
    {
      title: "Basic information",
      blocks: [
        {
          type: "companyBox",
          name: "Alfa Gym Sp. z o.o.",
          addressLines: [
            "40/1 Prezydenta Gabriela Narutowicza Street",
            "90-135 Lodz, Poland",
          ],
          metaLines: [
            "Tax ID (NIP): 7252354801",
            "REGON: 541553912",
            "KRS: 0001169812",
          ],
          email: "kontakt@alfagym.pl",
        },
        {
          type: "info",
          paragraphs: ["Contact"],
          strongFirst: true,
          labeled: [
            { label: "Email", text: "kontakt@alfagym.pl" },
            { label: "Phone", text: "+48 786 087 447" },
            { label: "Phone support hours", text: "10:00-14:00 on business days" },
            { label: "Email and contact form", text: "24/7" },
            { label: "Response time", text: "up to 48 hours on business days" },
          ],
        },
        {
          type: "info",
          paragraphs: ["Facility location"],
          strongFirst: true,
          labeled: [
            { label: "Facility", text: "Alfa Gym - self-service gym" },
            {
              label: "Address",
              text: "Unit 6, 6 Cedry Street, Lodz (marked with the “Alfa Gym Sp. z o.o.” sign)",
            },
            {
              label: "Note",
              text: "The Facility location is different from the Operator's registered office address.",
            },
          ],
        },
        {
          type: "info",
          paragraphs: ["Facility opening hours"],
          strongFirst: true,
          labeled: [{ label: "Hours", text: "daily from 5:00 to 24:00" }],
        },
        {
          type: "subsection",
          title: "Sales channels",
          blocks: [
            {
              type: "list",
              items: [
                "Online channel: sale of single entries, passes, and additional services, including the CheckUP service and CheckUP packages via the Service.",
                "On-site channel: sale of the CheckUP service performed at the Facility; the service may also be arranged by phone.",
              ],
            },
          ],
        },
        {
          type: "paragraph",
          text: "The related document for these Terms is the Privacy and Cookies Policy.",
        },
      ],
    },
    {
      title: "1. General provisions",
      blocks: [
        {
          type: "list",
          items: [
            "These Terms apply to online sales through the website www.alfagym.pl and the related booking system, as well as to on-site sales at the Facility to the extent specified herein.",
            "Using the Operator's services requires reading and accepting these Terms, especially for online purchases, and complying with all safety and house rules applicable at the Facility.",
            "The Operator's offer, price list, and service descriptions are available in the Service. A change to the price list does not constitute an amendment to these Terms.",
            "These Terms are available free of charge on the website www.alfagym.pl and, upon request, also by email.",
            "These Terms constitute standard contractual terms within the meaning of Article 384 of the Polish Civil Code.",
            "Acceptance of these Terms by the Client, especially by declaring acceptance in the Service, means that a service agreement has been concluded on the terms set out herein.",
          ],
        },
      ],
    },
    {
      title: "2. Definitions",
      blocks: [
        {
          type: "labeledParagraphs",
          items: [
            {
              label: "Service",
              text: "the website available at www.alfagym.pl, operated and administered by the Operator, enabling service bookings.",
            },
            {
              label: "Operator",
              text: "Alfa Gym Sp. z o.o., with its registered office in Lodz, 40/1 Prezydenta Gabriela Narutowicza Street, 90-135 Lodz, Poland, Tax ID 7252354801, REGON 541553912, KRS 0001169812.",
            },
            {
              label: "Facility / Gym",
              text: "the self-service sports and recreation facility branded Alfa Gym, located at Unit 6, 6 Cedry Street in Lodz, made available to Clients on the basis of a paid booking.",
            },
            {
              label: "Client / User",
              text: "a natural person using the Service or the Facility, especially a person making a booking or purchasing a service; an accompanying person is not a Client unless they conclude a separate agreement with the Operator.",
            },
            {
              label: "Agreement",
              text: "an agreement for the provision of services concluded between the Client and the Operator through the Service or at the Facility.",
            },
            {
              label: "Service / Services",
              text: "services provided by the Operator, including in particular making the Facility available during the reserved entry time, single entries, passes, the Technogym CheckUP service, and other services from the current offer.",
            },
            {
              label: "Electronic services",
              text: "services provided electronically, including enabling the conclusion of the agreement, making and paying for a booking, and sending email and SMS notifications related to service performance.",
            },
            {
              label: "Booking",
              text: "reserving a specific date, time, and entry period to the Facility within a purchased service or pass, effective upon confirmation in the Service.",
            },
            {
              label: "Entry time",
              text: "the specific time period during which the Client is entitled to use the Facility under the booking and purchased service.",
            },
            {
              label: "Billing Unit / Unit",
              text: "the billing unit corresponding to one reserved entry period under the service option purchased by the Client.",
            },
            {
              label: "Pass",
              text: "a named package of billing Units assigned to the Client, valid for 45 days from the date of purchase, unless the offer states otherwise.",
            },
            {
              label: "Access System",
              text: "the system used to control access to the Facility on the basis of an Access Code.",
            },
            {
              label: "Access Code",
              text: "an individual electronic code enabling entry to the Facility within a valid booking.",
            },
            {
              label: "Parking space",
              text: "the designated parking space assigned to the Facility.",
            },
            {
              label: "CheckUP Service",
              text: "a diagnostic and analytical service carried out by the Operator using the Technogym CheckUP device, performed only in the presence of the Operator or a person authorized by the Operator.",
            },
            {
              label: "Trainer",
              text: "a person conducting personal training, allowed to use the Facility only after prior verification and approval by the Operator.",
            },
            {
              label: "Accompanying person",
              text: "a natural person who is not the Client and who stays in the Facility only under the Client's booking, with the Client's consent and at the Client's responsibility, after prior notification to the Operator.",
            },
            {
              label: "Additional fee",
              text: "a flat-rate fee imposed by the Operator in the event of a breach of these Terms.",
            },
            {
              label: "Business days",
              text: "days from Monday to Friday, excluding public holidays in Poland.",
            },
          ],
        },
      ],
    },
    {
      title: "3. Sales channels and types of services",
      blocks: [
        {
          type: "list",
          items: [
            "The Operator sells services online via the Service and on-site within the scope of the CheckUP service.",
            "The agreement for the CheckUP service is concluded upon payment by the Client or, where payment is made on site, upon placing the order and its confirmation by the Operator.",
            "The CheckUP service is performed on a date agreed between the Client and the Operator.",
            "The performance date may be arranged either by the Operator contacting the Client within 48 hours of purchase or by the Client contacting the Operator.",
            "A lack of contact from either party does not release the parties from their duty to cooperate in arranging the performance date.",
            "The detailed scope of services, their prices, and conditions are always specified in the current offer made available through the Service.",
            "The Operator may introduce discount codes under the rules specified in the terms of a given promotion.",
            "As a rule, discount codes cannot be combined and usually do not apply to passes or CheckUP packages unless the terms of a specific promotion provide otherwise.",
          ],
        },
      ],
    },
    {
      title: "4. Electronic services",
      blocks: [
        {
          type: "list",
          items: [
            "The Client must provide true, complete, and up-to-date data necessary for the performance of the agreement, especially first name, last name, email address, and phone number.",
            "For bookings with an accompanying person, the Client must provide that person's full name and declares that they are entitled to provide those data and have informed that person about sharing them.",
            "For bookings with a Trainer, the Client selects a Trainer from the list available in the Service or obtains prior approval from the Operator for a Trainer outside the list.",
            "By providing the Trainer's data, the Client declares that they are entitled to do so and have informed the Trainer about the transfer of those data to the Operator.",
            "Providing false, incomplete, third-party, or outdated data, including data concerning accompanying persons or a Trainer, is prohibited.",
            "The Operator may perform a one-time or random verification of the consistency of the provided data with an identity document to the extent necessary to ensure safety and proper service performance.",
            "In the event of a material discrepancy, the Operator may refuse access to the Facility, cancel the booking, or suspend service performance until the matter is clarified.",
            "If the provision of false data makes it impossible to perform the agreement or contact the Client, this is treated as a circumstance attributable to the Client.",
            "The above does not exclude the Operator's right to pursue claims under general legal rules.",
            "Detailed rules regarding the processing of personal data are set out in the Privacy Policy available in the Service and at the Facility.",
          ],
        },
      ],
    },
    {
      title: "5. Passes and settlement rules",
      blocks: [
        {
          type: "list",
          items: [
            "The Operator's services may be settled through Passes expressed in billing Units.",
            "Each booking made under a Pass results in the deduction of one Unit according to the purchased entry-time option.",
            "A Pass is valid for 45 days from the date of purchase. After that period, any unused Units expire, subject to cases where booking is impossible for reasons attributable to the Operator.",
            "The CheckUP service is not settled under a Pass.",
            "Shortening the time of using the Facility does not entitle the Client to any refund.",
            "If making a booking is impossible for reasons attributable to the Operator, the Pass validity period is extended by the duration of that obstacle.",
            "Bookings under a Pass may be made up to 90 calendar days in advance.",
            "The Operator offers Passes with different numbers of Units and different entry-time options.",
            "Passes are personal unless the Operator expressly allows transferability.",
            "Failure to use a Pass for reasons not attributable to the Operator does not entitle the Client to a refund, validity extension, or exchange of unused entries for another benefit.",
          ],
        },
      ],
    },
    {
      title: "6. CheckUP service and CheckUP packages",
      blocks: [
        {
          type: "list",
          items: [
            "The CheckUP service is a diagnostic and analytical service carried out using the Technogym CheckUP device and performed only by the Operator or persons authorized by the Operator.",
            "The CheckUP service may be offered as a single service or as a package including 3, 6, or 9 CheckUP services.",
            "A CheckUP package entitles the Client to use a specified number of services within 90 days from the date of purchase.",
            "The agreement is concluded upon online payment when payment is made, upon on-site payment when the booking is made and confirmed by the Operator, and for direct on-site purchase when the Operator accepts the order.",
            "Booking a date for the CheckUP service is part of organizing the service and does not in itself constitute service performance.",
            "The Operator ensures that a performance date can be arranged within a reasonable time, taking availability into account.",
            "After purchasing a service or package, the Operator contacts the Client to arrange the date, and the Client may also contact the Operator independently.",
            "The Client is entitled to use the service or package within 90 days from purchase. If arranging the date is impossible for reasons attributable to the Operator, that period is extended accordingly.",
            "Failure to use the service for reasons attributable solely to the Client does not entitle the Client to any refund, subject to mandatory law.",
            "The Client may cancel an agreed date no later than 24 hours before the visit. If the visit is not cancelled on time or the Client fails to attend, the single service is deemed performed.",
            "It is prohibited to independently start or interfere with the Technogym CheckUP device without the supervision of the Operator or a person designated by the Operator.",
            "A breach of the above prohibition may result in an additional fee of PLN 2000 and the pursuit of damages under general legal rules.",
            "Use of the Technogym CheckUP device may involve the processing of the User's health-related data. Detailed information is provided in the Privacy Policy.",
            "CheckUP results may be made available via the Technogym app, the Operator's IT systems provided by the device manufacturer, or by email.",
          ],
        },
      ],
    },
    {
      title: "7. Bookings, lateness, and cancellations",
      blocks: [
        {
          type: "list",
          items: [
            "Bookings are made through the Service by selecting the date and entry time, providing the required data, and making payment.",
            "After the agreement is successfully concluded, the User receives an individual Access Code for the Facility in the TTLock system or another equivalent access-control system.",
            "The Access Code remains active only during the purchased entry period. During that period, the User may enter and leave the Facility multiple times, provided that this does not breach safety rules or these Terms.",
            "The User's late arrival does not extend the purchased entry period.",
            "If the User starts using the Facility later, they may use it only during the remaining booking time.",
            "The Facility may contain a time-counting system, including a clock or visual countdown system.",
            "After the purchased entry time ends, lighting systems or other installations may be automatically limited or switched off to signal the end of the booking.",
          ],
        },
        {
          type: "subsection",
          title: "Voluntary cancellation policy",
          blocks: [
            {
              type: "list",
              items: [
                "A booking may be cancelled no later than 24 hours before the start of the entry period.",
                "If the cancellation is effective, the User receives a voucher corresponding to the value of the unused service.",
                "Cancellations made after that deadline do not entitle the User to a voucher or refund, except where the inability to perform the service is attributable to the Operator.",
                "If the service cannot be used because of a failure of the access system, booking system, or the Facility itself, the User retains the right to use the service on another date or receive a voucher.",
                "A voucher is not granted if the inability to perform the service results from circumstances attributable to the User, especially the provision of incorrect data, improper use of the Access Code, or a breach of these Terms.",
              ],
            },
          ],
        },
      ],
    },
    {
      title: "8. Payments and sales documents",
      blocks: [
        {
          type: "list",
          items: [
            "Online payments are processed through the Paynow payment gateway.",
            "Online payment services are provided by mElements S.A.",
            "The User's payment data are processed exclusively by Paynow in accordance with its terms and privacy policy.",
            "All prices are stated in Polish zloty (PLN) and are gross prices unless the offer states otherwise.",
            "Available payment methods include payment cards, BLIK, and other methods made available in the Paynow gateway.",
            "Transaction confirmations and booking details are sent to the Client's email address; the SMS message contains at least the entry date, entry time, and Access Code.",
            "The Operator is not responsible for non-delivery of SMS messages for reasons attributable to telecom operators or the User's device.",
            "Order processing time is counted from successful payment authorization or, for deferred methods, from receipt of funds.",
            "The selected booking slot is temporarily blocked for 5 minutes to allow the transaction to be completed.",
            "On-site payments apply only to the CheckUP service and may be made in cash, by payment card, or by BLIK.",
            "Invoices are issued only if requested by the Client at the time of purchase. After the transaction ends, later invoice issuance is not possible.",
            "For on-site payments, the Operator issues a fiscal receipt and, if requested before payment, an invoice.",
            "Logos of card organizations and Paynow may be displayed in the Service for information purposes only and remain the property of their respective owners.",
            "The Operator is not a payment service provider and does not process the User's payment card data.",
          ],
        },
      ],
    },
    {
      title: "9. Access rules and eligible persons",
      blocks: [
        {
          type: "list",
          items: [
            "The Services and the Facility may be used only by adults, except where minors use the Facility under the continuous supervision of an adult.",
            "An adult supervising a minor must be present in the Facility for the entire duration of use, must be declared in accordance with these Terms, and bears full responsibility for the minor's safety and conduct.",
            "A Trainer may supervise a minor only if the Trainer has been declared in accordance with these Terms and holds appropriate qualifications.",
            "One guardian or Trainer may supervise no more than one minor.",
            "The User must use the equipment in accordance with its intended purpose, the instructions for use, and safety rules, and must immediately report any defects.",
            "Animals are prohibited in the Facility, except for assistance dogs within the meaning of applicable law.",
            "The Facility is a private space and, during a given time slot, is made available only to the User and persons declared in accordance with these Terms.",
            "Accompanying persons and the Trainer must be declared before the booking starts in the manner specified in the Service.",
            "The maximum number of people in the Facility depends on the selected service option. Exceeding that number constitutes a breach of these Terms.",
            "The User is liable for damage resulting from improper use of the Facility or equipment by the User, accompanying persons, the Trainer, or minors under the User's supervision.",
          ],
        },
      ],
    },
    {
      title: "10. Access to the Facility and use of access codes",
      blocks: [
        {
          type: "list",
          items: [
            "Entry to the Facility takes place using an individual Access Code provided to the User after purchasing the service by email and or SMS.",
            "The Access Code is assigned to a specific booking and time period, remains active only within the purchased time slot, and expires automatically after that period ends.",
            "The Access Code is confidential and may not be shared with third parties.",
            "Only the persons indicated during the purchase or booking process may use the Facility, in accordance with the terms of the relevant service.",
            "In the event of access problems, the User must immediately contact the Operator and describe the issue.",
            "If the inability to access the Facility results from causes attributable to the Operator or the Access System, the Operator will allow the service to be used on another date or grant a voucher equal to the value of the unused service.",
            "The Facility can always be exited from the inside regardless of the functioning of the Access System.",
            "The Operator is not liable for consequences resulting from the User sharing the Access Code with third parties.",
            "The Operator may temporarily suspend or block the User's access to the Facility in the event of a material breach of these Terms, attempts to use the Access System without authorization, or a justified suspicion of a security breach.",
          ],
        },
      ],
    },
    {
      title: "11. Monitoring and safety",
      blocks: [
        {
          type: "list",
          items: [
            "The Facility may be covered by CCTV monitoring in order to ensure the safety of persons and protect property.",
            "Using the Facility may involve recording the Client's image in accordance with applicable law.",
            "The Facility includes an area excluded from monitoring, such as showers, the toilet, and the changing room.",
            "Recordings are stored no longer than necessary to achieve the intended purpose, especially safety and the pursuit or defense of claims.",
          ],
        },
      ],
    },
    {
      title: "12. Personal trainer",
      blocks: [
        {
          type: "list",
          items: [
            "Using the Facility with a Trainer is allowed only under the relevant service option provided by the Operator.",
            "A Trainer may enter the Facility only after prior verification and approval by the Operator.",
            "A verified Trainer is entered into the Operator's internal trainer database.",
            "Trainer verification is carried out upon the request of the User or the Trainer through the available communication channels.",
            "As part of the verification process, the Trainer must provide documents confirming their qualifications to conduct personal training.",
            "The Operator may refuse to approve a Trainer if formal or safety requirements are not met.",
            "Until the verification process is completed, the User may use the Facility with a Trainer only by purchasing a service intended for at least two persons; in such a case, the Trainer is treated as an accompanying person.",
            "The Operator is not responsible for the quality, manner, or effects of training conducted by a Trainer who is not a party to the agreement between the Operator and the User.",
            "Conducting business activities involving training services at the Facility may require additional organizational conditions to be met or a separate agreement with the Operator.",
          ],
        },
      ],
    },
    {
      title: "13. Liability of the User and accompanying persons",
      blocks: [
        {
          type: "list",
          items: [
            "The User is responsible for their own acts and omissions, as well as the acts and omissions of persons using the Facility under that booking, including accompanying persons and Trainers.",
            "The Client and accompanying persons are liable for damage caused to the Operator in connection with the use of the Facility, in accordance with civil law.",
            "If damage is caused by several persons, the Operator may pursue claims against each of them in accordance with the liability rules provided by law.",
            "The Operator is not liable for injuries or damage resulting from improper use of equipment, breaches of these Terms, or failure to adapt activity to the health condition of the User or persons acting under the User's booking.",
            "The Operator is responsible for maintaining the Facility and equipment in a condition compliant with applicable safety requirements.",
            "These Terms do not exclude or limit the Operator's liability to the extent that such exclusion or limitation is prohibited by mandatory law.",
            "The Operator is not responsible for items brought into or left in the Facility unless the damage was caused by the Operator's intentional fault or gross negligence. The Client must lock the locker made available by the Operator.",
          ],
        },
      ],
    },
    {
      title: "14. House rules, hygiene, quiet use, and safety",
      blocks: [
        {
          type: "list",
          items: [
            "The User uses the Facility at their own responsibility, taking into account their health condition and individual physical capabilities.",
            "A medical consultation before starting physical activity is recommended, especially in the case of chronic diseases, injuries, or other health contraindications.",
            "It is prohibited to perform exercises in a manner posing a risk to the health or life of the User or third parties.",
            "The User must use the Facility in accordance with hygiene, safety, and social coexistence rules.",
            "After entering the Facility, the User must change into clean sports footwear intended solely for exercise. This obligation also applies to accompanying persons and the Trainer.",
            "The User must use a towel during training.",
            "After each use of training equipment, the contact surfaces must be cleaned using disinfectants and disposable materials provided at the Facility.",
            "After using the Facility, the User must leave it in no worse condition, in particular by returning equipment to its proper place and disposing of waste in designated bins.",
            "Smoking tobacco products and e-cigarettes, consuming alcohol, using intoxicants, doping substances, or other psychoactive substances, and being present under their influence are strictly prohibited at the Facility.",
            "Throwing weights or equipment, hitting equipment, damaging it, or using it contrary to its intended purpose is prohibited.",
            "Use of showers is permitted only within the purchased period of use of the Facility.",
            "Commercial recordings, photo sessions, or audiovisual materials require the Operator's prior consent. Private recordings are allowed only if they do not infringe the privacy of others, the law, or safety rules.",
            "In the event of smoke, fire, flooding, alarm activation, or another danger, the User must immediately evacuate and, if necessary, notify the relevant services and the Operator.",
            "The User must promptly report any noticed damage to the Facility or equipment, as well as a lack of hygiene products or consumables.",
            "The User must keep evacuation routes clear and must not interfere with devices or elements of safety systems.",
          ],
        },
      ],
    },
    {
      title: "15. Parking space",
      blocks: [
        {
          type: "list",
          items: [
            "A parking space designated for the Client is available next to the Facility during the booking period.",
            "Arrival and departure during the booking are permitted.",
            "A buffer of 5 minutes before the booking starts and 10 minutes after it ends applies.",
            "The Client must vacate the parking space no later than after the buffer period so that it can be used by the next Client.",
          ],
        },
      ],
    },
    {
      title: "16. Additional fees",
      blocks: [
        {
          type: "alert",
          text: "If these Terms are breached, the Operator may charge the Client additional fees.",
        },
        {
          type: "list",
          items: [
            "PLN 500 for remaining in the Facility after the end of the entry time, occupying the parking space after the buffer period, sharing the Access Code with an unauthorized person, or using the Facility with more persons than allowed under the purchased service.",
            "PLN 2000 for independent use of the Technogym CheckUP device without the presence or supervision of the Operator.",
            "Additional fees are charged for each confirmed breach on the basis of system data, CCTV records, Access System logs, or other reliable evidence.",
            "Additional fees are not charged if the breach resulted from a failure of the Access System or other causes attributable to the Operator.",
            "Charging an additional fee does not exclude the Operator's right to claim damages under general legal rules if the loss exceeds the amount of the fee.",
            "Irrespective of additional fees, the Operator may charge the User for cleaning, servicing, repair, or removal of damage caused by the User, accompanying persons, the Trainer, or minors under the User's supervision.",
            "Additional fees and related costs are payable within 7 days from delivery of the payment demand sent by email or post.",
            "Failure to pay on time may result in temporary or permanent blocking of access to the Facility, subject to the User's rights under mandatory law.",
          ],
        },
      ],
    },
    {
      title: "17. Operator liability and exclusions",
      blocks: [
        {
          type: "list",
          items: [
            "The User uses the Facility and its equipment at their own risk.",
            "The Operator does not provide accident insurance as part of the service price.",
            "The Operator is not liable for damage resulting from improper or unintended use of equipment, failure to follow instructions for use or safety rules, the User's health condition, or a breach of these Terms.",
            "The Operator's liability towards Users who are consumers or entrepreneurs enjoying consumer rights is limited only to the extent permitted by mandatory law.",
            "These Terms do not exclude or limit the Operator's liability for personal injury or other liability that cannot lawfully be excluded.",
            "The Operator exercises due care to ensure proper functioning of the Facility, its equipment, and the Access System, but does not guarantee uninterrupted availability.",
            "Access to the Facility may be temporarily limited or suspended in the event of technical failures, servicing, maintenance or modernization works, force majeure, or other events beyond the Operator's control.",
            "If the Facility becomes unavailable, the Operator will take steps to remove the interruption as quickly as possible.",
            "This section does not exclude the User's rights arising from law in cases of non-performance or improper performance of the agreement.",
          ],
        },
      ],
    },
    {
      title: "18. Complaints",
      blocks: [
        {
          type: "list",
          items: [
            "Complaints may be submitted by email to kontakt@alfagym.pl.",
            "A complaint should include at least the Client's contact details, the date and time of the booking or purchase, a description of the event, and the Client's request.",
            "The Operator confirms receipt of the complaint in the same form in which it was submitted, unless the Client indicates another preferred form of contact.",
            "The Operator examines the complaint within 14 calendar days from receipt or from the completion of formal deficiencies.",
            "A response to the complaint is provided electronically or in writing, according to the Client's choice.",
            "Complaints concerning online payments may require contact with the Paynow payment gateway operator.",
          ],
        },
      ],
    },
    {
      title: "19. Withdrawal from the agreement and voluntary refunds",
      blocks: [
        {
          type: "list",
          items: [
            "Where the agreement is concluded at a distance, the Consumer has the right to withdraw from the agreement within 14 days in accordance with the Consumer Rights Act.",
            "The right of withdrawal does not apply to agreements for services related to leisure activities if the agreement specifies the day or period of service performance.",
            "Entering into an agreement for a time-specific service constitutes an express request for performance at the specified time and may therefore result in the lack of a statutory right of withdrawal.",
            "Regardless of the above, the Operator may, in particularly justified cases, grant the User a voluntary benefit in the form of a voucher corresponding to the value of the unused service.",
            "The voucher is single-use, is not exchangeable for cash, and may be used only within its validity period, which is generally 30 days from the date of issue unless the Operator states otherwise.",
            "The voucher may be used through the Service by selecting the option to use it during the booking process.",
            "For the CheckUP service, the Operator may, after individual arrangements, grant a voucher that may be used only for the CheckUP service.",
            "The provisions of this section do not exclude or limit any Consumer rights arising from mandatory law.",
          ],
        },
      ],
    },
    {
      title: "20. Final provisions",
      blocks: [
        {
          type: "list",
          items: [
            "These Terms enter into force on the date indicated in their content and are published on the Operator's website in their current version.",
            "The Operator reserves the right to amend these Terms for important reasons, especially in the event of changes to the scope or method of service provision, introduction of new Service functionalities, changes in applicable law, or the need to remove ambiguities, correct errors, or adapt the Terms to organizational or technical changes.",
            "Amendments to these Terms do not affect rights already acquired by Users in relation to services purchased before the effective date of the amendments, unless the amendment results from mandatory law.",
            "Polish law shall govern the conclusion and performance of the agreement, subject to mandatory provisions of European Union law.",
            "Any disputes arising from the agreement or related to the use of the Facility shall be resolved by the competent common courts in accordance with applicable law.",
            "In matters not regulated by these Terms, generally applicable provisions of law shall apply, in particular the Civil Code and the Consumer Rights Act.",
            "These Terms are drafted in Polish. If versions in other languages are made available, the Polish version shall prevail.",
          ],
        },
      ],
    },
  ],
  contactCard: {
    title: "Questions about these Terms?",
    lead: "Contact us:",
    emailLabel: "Email",
    email: "kontakt@alfagym.pl",
    addressLabel: "Correspondence address",
    addressLines: [
      "Alfa Gym Sp. z o.o.",
      "40/1 Prezydenta Gabriela Narutowicza Street",
      "90-135 Lodz, Poland",
    ],
    note: "For urgent matters, you may also call us at +48 786 087 447.",
  },
};
